import classNames from "classnames";
import React, { CSSProperties, FunctionComponent } from "react";
import { Button } from "Shared";
import "./index.scss";

interface Props {
    className?: string;
    style?: CSSProperties;
    text?: string;
    onClick?(): void;
}

const RoundedButton: FunctionComponent<Props> = ({ children, className, text, style, onClick }) => (
    <Button
        className={classNames(`RoundedButton`, {
            [`${className}`]: className,
        })}
        style={style}
        text={text}
        onClick={onClick}
    >
        {children}
    </Button>
);

export default RoundedButton;
